__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@rti-control/geofence_editor";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@dksfrontend/dks-frontend-ui-lib", "0.2.5", function() { return Promise.all([__webpack_require__.e(62), __webpack_require__.e(843)]).then(function() { return function() { return __webpack_require__(8062); }; }); });
			register("@element-plus/icons-vue", "2.3.1", function() { return __webpack_require__.e(548).then(function() { return function() { return __webpack_require__(8548); }; }); });
			register("@mapbox/mapbox-gl-draw", "1.3.0", function() { return __webpack_require__.e(358).then(function() { return function() { return __webpack_require__(4358); }; }); });
			register("@mapbox/mapbox-gl-draw", "1.4.3", function() { return __webpack_require__.e(807).then(function() { return function() { return __webpack_require__(3188); }; }); });
			register("@maplibre/maplibre-gl-geocoder", "1.5.0", function() { return __webpack_require__.e(797).then(function() { return function() { return __webpack_require__(5797); }; }); });
			register("@vue/apollo-composable", "4.0.0-beta.12", function() { return Promise.all([__webpack_require__.e(211), __webpack_require__.e(933), __webpack_require__.e(907)]).then(function() { return function() { return __webpack_require__(5933); }; }); });
			register("element-plus", "2.10.7", function() { return Promise.all([__webpack_require__.e(786), __webpack_require__.e(157), __webpack_require__.e(907), __webpack_require__.e(469)]).then(function() { return function() { return __webpack_require__(3157); }; }); });
			register("graphql", "16.8.1", function() { return __webpack_require__.e(216).then(function() { return function() { return __webpack_require__(6216); }; }); });
			register("maplibre-gl-js-amplify", "3.1.0", function() { return Promise.all([__webpack_require__.e(886), __webpack_require__.e(528), __webpack_require__.e(188), __webpack_require__.e(180), __webpack_require__.e(635)]).then(function() { return function() { return __webpack_require__(5886); }; }); });
			register("pinia", "2.3.1", function() { return Promise.all([__webpack_require__.e(899), __webpack_require__.e(907)]).then(function() { return function() { return __webpack_require__(5899); }; }); });
			register("vue-i18n", "11.1.11", function() { return function() { return __webpack_require__(2543); }; }, 1);
			register("vue-router", "4.5.1", function() { return function() { return __webpack_require__(5220); }; }, 1);
			register("vue-sonner", "1.1.3", function() { return Promise.all([__webpack_require__.e(390), __webpack_require__.e(61)]).then(function() { return function() { return __webpack_require__(5390); }; }); });
			register("vue", "3.5.21", function() { return function() { return __webpack_require__(785); }; }, 1);
			initExternal(7473);
			initExternal(1655);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};